import { render, staticRenderFns } from "./spaces.vue?vue&type=template&id=772802f9&scoped=true"
import script from "./spaces.vue?vue&type=script&lang=js"
export * from "./spaces.vue?vue&type=script&lang=js"
import style0 from "./spaces.vue?vue&type=style&index=0&id=772802f9&prod&scoped=true&lang=scss"
import style1 from "./spaces.vue?vue&type=style&index=1&id=772802f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772802f9",
  null
  
)

export default component.exports